<!-- <div>
    <p><strong>First Name: </strong> {{profile?.givenName}}</p>
    <p><strong>Last Name: </strong> {{profile?.surname}}</p>
    <p><strong>Email: </strong> {{profile?.userPrincipalName}}</p>
</div> -->
<br>
<br>
<br>
<br>
<br>
<br>
<br>

<!-- app.component.html -->
<div style="text-align: center; margin-top: 50px;">
  <h1>PAGE NOT FOUND</h1>
  <h2>404 Error..!</h2>

  <h3>Kindly contact admin</h3>


    <!-- <input 
      type="text" 
      [(ngModel)]="inputValue" 
      placeholder="Enter some text"
    />
    <button (click)="saveToLocalStorage()">Save</button>
  
    <div style="margin-top: 20px;">
      <h2>Stored Value:</h2>
      {{ storedValue }}
    </div> -->
  </div>
  